// External dependencies.
import swal from "sweetalert";
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";

/**
 * Class used to handle the wholesale register form front-end.
 *
 * @since 1.5.0
 * @class WholesaleRegisterForm
 */
class WholesaleRegisterForm {
    /**
     * Creates an instance of WholesaleRegisterForm.
     * 
     * @since 1.5.0
     * @memberof WholesaleRegisterForm
     */
    constructor() {
        this.formElement = document.querySelector( '.js-wholesale-register-form' );
        this.submitElement = ( this.formElement ) ? this.formElement.querySelector( 'button[type="submit"]' ) : null;

        this.events = this.events.bind( this );
        this.resetSubmitElement = this.resetSubmitElement.bind( this );
        this.sendForm = this.sendForm.bind( this );
        this.handleSuccess = this.handleSuccess.bind( this );
        this.handleError = this.handleError.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 1.5.0
     * @listens .js-wholesale-register-form~event:submit
     * @memberof WholesaleRegisterForm
     */
    events() {
        this.formElement && this.formElement.addEventListener( 'submit', this.sendForm );
    }

    /**
     * Resets the submit element to its original state.
     *
     * @since 1.5.0
     * @memberof WholesaleRegisterForm
     */
    resetSubmitElement() {
        const { sendText } = this.submitElement.dataset;
        this.submitElement.removeAttribute( 'disabled' );
        this.submitElement.textContent = sendText;
    }

    /**
     * Send the form.
     *
     * @since 1.5.0
     * @param {object} e
     * @memberof WholesaleRegisterForm
     */
    async sendForm( e ) {
        e.preventDefault();

        const { sendingText } = this.submitElement.dataset;
        const url = this.formElement.getAttribute( 'action' );
        const body = new FormData( this.formElement );
        const method = 'POST';

        this.submitElement.setAttribute( 'disabled', true );
        this.submitElement.textContent = sendingText;

        try {
            const res = await apiFetch( { url, body, method } );
            this.handleSuccess( res );
        } catch ( error ) {
            this.handleError( error );
        }

        grecaptcha.reset();
        this.resetSubmitElement();
    }

    /**
     * Handles the form's success action.
     *
     * @since 1.5.0
     * @param {object} res
     * @memberof WholesaleRegisterForm
     */
    handleSuccess( res ) {
        const { name } = window.app;
        this.formElement.reset();

        swal( {
            title: name,
            text: res.data,
            icon: 'success',
            buttons: {
                confirm: {
                    text: __( 'Aceptar', 'tio-simon-foods' ),
                    className: 'btn btn-ts-primary'
                }
            }
        } );
    }

    /**
     * Handles the form's error action.
     *
     * @since 1.5.0
     * @param {object} error
     * @memberof WholesaleRegisterForm
     */
    handleError( error ) {
        console.log( error );
        const { name } = window.app;
        let content = '';

        if ( error.data ) {
            if ( 'object' === typeof error.data ) {
                for ( const key in error.data ) {
                    if ( error.data.hasOwnProperty( key ) ) {
                        const element = error.data[ key ];
                        content += `${element}<br>`;
                    }
                }
            } else {
                content = error.data;
            }
        } else {
            content = __( 'Ha ocurrido un error procesando tu petición. Por favor actualiza la página e intenta nuevamente.', 'tio-simon-foods' );
        }

        const divElement = document.createElement( 'div' );
        divElement.innerHTML = content;

        swal( {
            title: name,
            content: divElement,
            icon: 'error',
            buttons: {
                confirm: {
                    text: __( 'Aceptar', 'tio-simon-foods' ),
                    className: 'btn btn-ts-primary'
                }
            }
        } ).then( () => divElement.remove() );
    }
}

export default WholesaleRegisterForm;
